import {combineReducers} from 'redux';

import {IUserStoreState, IUserActionTypes, UserAppState} from './user-types';
import {
  UPDATE_USER_DETAILS,
  TOGGLE_LOADING_USER_DETAILS,
  TOGGLE_EMAIL_LOADING,
} from './user-constants';

const initialState: IUserStoreState = {
  isLoading: true,
  userInfo: {},
  walletInfo: {},
  earnMore: {},
  isLoggedIn: true,
  isEmailLoading: false,
  updateKycPopup: {},
  data_masked: true,
};

export function userDetailsReducer(state = initialState, action: IUserActionTypes) {
  switch (action.type) {
    case UPDATE_USER_DETAILS:
      return {
        ...state,
        ...action.actionData,
      };

    case TOGGLE_LOADING_USER_DETAILS:
      return {
        ...state,
        isLoading: action.actionData,
      };

    case TOGGLE_EMAIL_LOADING:
      return {
        ...state,
        isEmailLoading: action.actionData,
      };

    default:
      return state;
  }
}

export const userReducer = {
  user: userDetailsReducer,
};

export const rootReducer = combineReducers(userReducer);
